const initialState = {
  isLoading: false,
  data: {},
};

export const modalActiveUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_STATE_ACTIVE":
      return {
        ...state,
        isLoading: true,
      };

    case "GET_ACTIVE_SUCCESS":
      return {
        ...state,
        isLoading: false,
        data: action.payload,
      };

    default:
      return state;
  }
};
